import { generateUuid } from '../_util/utils';
import { useMemoizedFn, useSafeState, useUnmountedRef, useUpdateEffect } from 'ahooks';
import { useEffect, useRef } from 'react';
export const useFinalRequest = function (request) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    ready = true,
    manual = false,
    defaultParams = [],
    initialData,
    refreshDeps = [],
    onBefore,
    onSuccess
  } = options;
  const lastRequest = useRef();
  const isUnmounted = useUnmountedRef();
  const [loading, setLoading] = useSafeState(false);
  const [data, mutate] = useSafeState(initialData);
  const runAsync = useMemoizedFn(async function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    const params = args.length ? args : defaultParams;
    if (!ready) {
      return;
    }
    if (onBefore) {
      const ok = await onBefore(params);
      if (ok === false) {
        return;
      }
    }
    const requestId = generateUuid();
    lastRequest.current = {
      id: requestId,
      params
    };
    setLoading(true);
    const response = await request(...params);
    if (isUnmounted.current) {
      return;
    }
    if (requestId === lastRequest.current.id) {
      if (onSuccess) {
        await onSuccess(response, params);
      }
      mutate(response);
      setLoading(false);
    }
  });
  const run = useMemoizedFn(function () {
    runAsync(...arguments);
  });
  const refreshAsync = useMemoizedFn(async () => {
    var _lastRequest$current$, _lastRequest$current;
    const params = (_lastRequest$current$ = (_lastRequest$current = lastRequest.current) === null || _lastRequest$current === void 0 ? void 0 : _lastRequest$current.params) !== null && _lastRequest$current$ !== void 0 ? _lastRequest$current$ : [];
    await runAsync(...params);
  });
  const refresh = useMemoizedFn(() => {
    refreshAsync();
  });
  useUpdateEffect(() => {
    if (!lastRequest.current) {
      return;
    }
    refresh();
  }, refreshDeps);
  useEffect(() => {
    if (!manual && ready) {
      refresh();
    }
  }, [ready]);
  return {
    loading,
    data,
    mutate,
    run,
    runAsync,
    refresh,
    refreshAsync
  };
};